import React from 'react';
import DataSource from 'devextreme/data/data_source';
import CustomStore from 'devextreme/data/custom_store';
import Guid from "devextreme/core/guid";
import AuthStore from '../store/AuthStore';
import LicenceCache from '../components/cache/LicenceCache';

async function handleResponseLocal(response) {
    if (!response.ok) {
        throw Error(response.statusText ? response.statusText : response.status);
    }
    else {
        return response.json().then(data =>
            {
                if (data && data.error) {
                    throw Error(data.error.text);
                }
                return {
                    data: data.data,
                }
            }
        );
    }
    return response;
}

async function handleResponse(response) {
//    return await handleResponseLocal(response).catch((e) => { throw new Error('Data Loading Error \n' + e.message); });
    return await handleResponseLocal(response).catch((e) => { throw e });
}

export interface ISmartFetchConfig {
    authStore: AuthStore,
    url: string,
    config: any,
    isReplay?: boolean,
    cacheDuration?: number,
    returnDataAsNoObject?: boolean,
    isBlob?: boolean;
}

const proceddHeaders = (headers) => {
    if (!headers) return;
    if (headers['Content-Type'] == undefined) {
        delete headers['Content-Type'];
    }
}

export async function smartFetch(
    smartFetchConfig: ISmartFetchConfig
) {
    //smartFetchConfig.config.headers = getHeaders();
    smartFetchConfig.config.headers = Object.assign(getHeaders(), smartFetchConfig.config.headers);
    proceddHeaders(smartFetchConfig.config.headers);
    let response = await fetch(smartFetchConfig.url, smartFetchConfig.config);
    if (!response.ok) {
        if (response.status == 401 && !smartFetchConfig.isReplay && smartFetchConfig.authStore) {
            await smartFetchConfig.authStore.refresh();
//            smartFetchConfig.authStore.refresh();
            smartFetchConfig.isReplay = true;
            return await smartFetch(smartFetchConfig);
        }
        else {
            if (response.status == 401 && smartFetchConfig.authStore) {
                smartFetchConfig.authStore.setAuthInfoAuthStore(null);
            }
            throw Error(response.statusText ? response.statusText : "" + response.status);
        }
    }
    else {
        smartFetchConfig.isReplay = false;
        let res;
        if (smartFetchConfig.isBlob == true) {
            res = await response.blob();
        }
        else {
            res = await response.json();
        }
        return res;
    }
}

export async function getSmartFetchData(smartFetchConfig: ISmartFetchConfig) {
    const cacheKey = smartFetchConfig.url;
    const cacheDuration = smartFetchConfig.authStore.cacheDurations[cacheKey] ?? (smartFetchConfig.cacheDuration ?? 0);

    if (cacheDuration > 0) {
        let cacheResult = LicenceCache.getFromCache(smartFetchConfig.authStore, cacheKey);
        if (cacheResult.result) {
            return cacheResult.value;
        }
    }
    let data = await smartFetch(smartFetchConfig);
    if (data && data.error) {
        throw Error(data.error.text);
    }
    let res;
    if (smartFetchConfig.isBlob == true) {
        res = data;
    }
    else {
        if (smartFetchConfig.returnDataAsNoObject)
            res = data.data;
        else
            res = { data: data.data }
    }
    if (cacheDuration > 0 || smartFetchConfig.cacheDuration > 0) {
        const newCacheDuration = Math.max(cacheDuration, smartFetchConfig.cacheDuration);
        LicenceCache.setToCache(smartFetchConfig.authStore, cacheKey, res, newCacheDuration);
        smartFetchConfig.authStore.cacheDurations[cacheKey] = newCacheDuration;
    }
    return res;
}


const getHeaders = () => {
    return {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
    }
}

export interface ILicenceStoreConfig {
    url: string;
    filter?: string | string[];
    authStore: AuthStore;
    cacheDuration?: number;
    keyName?: string;
    byKeyInSearch?: boolean;
    groupName?: string;
    loadMode?: 'processed' | 'raw';
    includeTables?: string;
    headers?: object;
}

export default class LicenceDataSource {
    //    static baseUrl = 'https://localhost:5001";
//    static baseUrl = 'http://localhost:5000';
    //    static baseUrl = 'http://192.168.1.70:5000';
    //    static baseUrl = process.env.BASEURL;
    static baseUrl = window.location.origin;

    static productUrl = LicenceDataSource.baseUrl + '/api/main/products';
    static corporationUrl = LicenceDataSource.baseUrl + '/api/main/corporations';
    static parthnerUrl = LicenceDataSource.baseUrl + '/api/main/parthners';
    static postUrl = LicenceDataSource.baseUrl + '/api/main/posts';
    static productGroupUrl = LicenceDataSource.baseUrl + '/api/main/productgroups';
    static orderUrl = LicenceDataSource.baseUrl + '/api/main/orders';
    static orderDetailUrl = LicenceDataSource.baseUrl + '/api/main/orderDetails';
    static dealerUrl = LicenceDataSource.baseUrl + '/api/main/dealers';
    static objectUrl = LicenceDataSource.baseUrl + '/api/main/objects';
    static licenceUrl = LicenceDataSource.baseUrl + '/api/main/licences';
//    static reportUrl = LicenceDataSource.baseUrl + '/api/main/reports';
    static reportUrl = LicenceDataSource.baseUrl + '/api/main/reports';
    static reportDataUrl = LicenceDataSource.baseUrl + '/api/reportData';
    static reportDataByCodeUrl = LicenceDataSource.baseUrl + '/api/reportData/byCode';
    static tenantUrl = LicenceDataSource.baseUrl + '/api/main/tenants';
    static claimUrl = LicenceDataSource.baseUrl + '/api/main/claims';
    

    static userUrl = LicenceDataSource.baseUrl + '/api/jwt/users';
    static roleUrl = LicenceDataSource.baseUrl + '/api/jwt/roles'; 

    static groupNamesUrl = LicenceDataSource.baseUrl + "/api/utils/getGroupNames";


    static defaultParentGuid = new Guid("00000000-0000-0000-0000-000000000000");
    static defaultGuid = new Guid("00000000-0000-0000-0000-000000000000");

    static getUrlObj(url) {
        let urlObj;
        try {
            urlObj = new URL(url);
        }
        catch {
            urlObj = new URL(url, LicenceDataSource.baseUrl);
        }
        return urlObj;
    }
    static getUrlStr(url, filter, includeTables=null) {
        let urlObj = LicenceDataSource.getUrlObj(url);
        let params = {};
        if (filter) {
            if (Array.isArray(filter)) {
                (filter || []).map((item, index) => params["filter[" + index + "]"] = item);
            }
            else {
                params["filter"] = filter;
            }
        }
        if (includeTables) {
            params["includeTables"] = includeTables;
        }
        if (!urlObj.search) {
            urlObj.search = new URLSearchParams(params).toString();
        }
        return urlObj.toString();
    }

    static licenceStore(
        config: ILicenceStoreConfig
    ) {
        config.keyName = config.keyName || 'Id';
        let customStoreConfig = {
            loadMode: config.loadMode,
            key: config.keyName,
            load: (loadOptions) => {
                console.log(loadOptions);
//                filter = filter ? ("filter=" + filter) : "";
//                let urlObj = new URL(config.url);
/*
                let urlObj = LicenceDataSource.getUrlObj(config.url);
                let params = {};
                if (config.filter) {
                    params["filter"] = config.filter;
                }
                if (!urlObj.search) {
                    urlObj.search = new URLSearchParams(params).toString();
                }
*/
                return getSmartFetchData(
                    {
                        authStore: config.authStore,
                        url: LicenceDataSource.getUrlStr(config.url, config.filter),// urlObj.toString(),
                        config: {},
                        cacheDuration: config.cacheDuration ?? 0,
                        returnDataAsNoObject: config.loadMode=="raw",
                    }
                )
            },
            insert: (values) => {
                config.authStore.cacheDurations[config.url] = 0;
                return getSmartFetchData(
                    {
                        authStore: config.authStore,
                        url: `${config.url}/add`,
                        config: {
                            method: 'POST',
                            body: JSON.stringify(
                                {
                                    values: values
                                }),
                        },
                    }
                )
            },
            remove: (key) => {
                config.authStore.cacheDurations[config.url] = 0;
//                return smartFetch(
                return getSmartFetchData(
                    {
                        authStore: config.authStore,
                        url: `${config.url}/delete`,
                        config: {
                            method: 'POST',
                            body: JSON.stringify(
                                {
                                    key: key
                                }),
                        },
                    }
                )
            },
            update: (key, values) => {
                config.authStore.cacheDurations[config.url] = 0;
                return getSmartFetchData(
                    {
                        authStore: config.authStore,
                        url: `${config.url}/update`,
                        config:
                        {
                            method: 'POST',
                            body: JSON.stringify(
                                {
                                    key: key,
                                    values: values
                                }),
                        }
                    }
                )
            },
        };
        if (config.loadMode != "raw") {
            customStoreConfig["byKey"] = (key) => {
                let urlObj;
                if (config.byKeyInSearch) {
                    urlObj = LicenceDataSource.getUrlObj(config.url);
                }
                else {
                    urlObj = LicenceDataSource.getUrlObj(config.url + "/" + key.toString());
                }
                let params = {};
                if (config.byKeyInSearch) {
                    params["filter"] = config.keyName + " eq " + key.toString();
                }
                urlObj.search = new URLSearchParams(params).toString();
                let res = getSmartFetchData(
                    {
                        authStore: config.authStore,
                        url: urlObj.toString(),
                        config: {},
                        returnDataAsNoObject: true,
                    }
                )
                return res;
            }
        }
        const customDataSource = new CustomStore(customStoreConfig);
        return customDataSource;
    }
    static licenceDataSource(
        config: ILicenceStoreConfig
    ) {
        const dataSource = new DataSource({
            store: LicenceDataSource.licenceStore(config),
            group: config.groupName,            
        });
        return dataSource;
    }
}

export async function downLoadByUrl (toFileName,
    config: ILicenceStoreConfig)
{
    const response = await getSmartFetchData(
        {
            authStore: config.authStore,
            url: config.url,
            config: {},
            cacheDuration: config.cacheDuration ?? 0,
        }
    );
    let blob = new Blob([JSON.stringify(response.data, null, 2)], { type: 'application/json' });
    let localUrl = window.URL.createObjectURL(blob);
    let a = document.createElement('a');
    a.href = localUrl;
    a.download = toFileName;
    document.body.appendChild(a);
    a.click();
    URL.revokeObjectURL(localUrl);
    document.body.removeChild(a);
}

export async function downLoadBlobByUrl0(
    config: ILicenceStoreConfig) {
    const response = await getSmartFetchData(
        {
            authStore: config.authStore,
            url: config.url,
            config: {},
            cacheDuration: config.cacheDuration ?? 0,
            isBlob: true,
        }
    );
//    let base64 = response.data["File"];
//    let file = atob(base64);
    let blob = response;
//    let toFileName = response.data["FileName"];
//    let blob = new Blob([file], { type: 'application/zip' });
    let localUrl = window.URL.createObjectURL(blob);
//    console.log("localUrl.length =" + localUrl.length);
//    localUrl = response.data["File"];
//    console.log("localUrl.length =" + localUrl.length);
    let a = document.createElement('a');
    a.href = localUrl;
 //   let toFileName = response.data["FileName"];
//    a.download = "toFileName";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
}

const b64toBlob = (b64Data, contentType = '', sliceSize = 512) => {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
}
export async function downLoadBlobByUrl(
    config: ILicenceStoreConfig) {
    const response = await getSmartFetchData(
        {
            authStore: config.authStore,
            url: config.url,
            config: {},
            cacheDuration: config.cacheDuration ?? 0,
        }
    );
    let toFileName = response.data["FileName"];
    let base64 = response.data["File"];
    let blob = b64toBlob(base64);
    let localUrl = window.URL.createObjectURL(blob);
    let a = document.createElement('a');
    a.href = localUrl;
    a.download = toFileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
}

export async function UpLoadByUrl(
    body,
    config: ILicenceStoreConfig) {
    const response = await getSmartFetchData(
        {
            authStore: config.authStore,
            url: config.url,
            config: {
                method: 'POST',
                body: body,
                headers: config?.headers,
//                body: JSON.stringify( body ),
//                body: JSON.stringify({ values: body }),
            },
            cacheDuration: config.cacheDuration ?? 0,
        }
    );
    return response;
}

